export default {
    setPermisos(state, payload) {
        state.permisos = payload;
    },
    setMobile(state, payload) {
        state.isMobile = payload;
    },
};
